import { BaseModel } from "./base.model";

export class ErrorModel extends BaseModel {
    message?: string;
    stackTrace?: string;
    source?: string;
    statusCode?: number;
    i18nCode?: string;
}
